import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPopupId: null,
  popupData: {},
  enableButtons: false,
  isLocationPopupLoaded: false,
};

const popupsSlice = createSlice({
  name: "popups",
  initialState,
  reducers: {
    openPopup: (state, action) => {
      const { popupId, data, enableButtons } = action.payload;
      state.currentPopupId = popupId;
      state.popupData = data || {};
      state.enableButtons = enableButtons;
    },
    closePopup: (state) => {
      state.currentPopupId = null;
      state.popupData = {};
    },
    setIsLocatonPopupLoaded: (state, action) => {
      const { isLocationPopupLoaded } = action.payload;
      state.isLocationPopupLoaded = isLocationPopupLoaded;
    },
  },
});

export const { openPopup, closePopup, setIsLocatonPopupLoaded } =
  popupsSlice.actions;
export default popupsSlice.reducer;
